import { Card, Grid, Typography } from "@material-ui/core";
import MainContainer from "./containers/MainContainer";
import TopBar from "./containers/TopBar";

import Global from "../assets/css/style";
import { dateFormat, permuteCount, datePhpFormat2 } from "../utils/functions";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const DesignEachNumber = ({
	eachBet,
	board,
	boardKey,
	e_date = false,
	date = "",
	win = 0,
}) => {
	const bgStyle = e_date
		? win
			? { backgroundColor: "green" }
			: { backgroundColor: "transparent" }
		: null;
	const fontStyle = e_date ? (win ? "#fff" : Global.color) : Global.color;
	const fontStyle2 = e_date ? (win ? "#fff" : "#6D6D6D") : "#6D6D6D";

	return (
		<div className="number-container" key={boardKey} style={bgStyle}>
			<Grid container className="per-number">
				<Grid
					item
					xs={6}
					container
					style={{
						flexDirection: "column",
					}}
				>
					<Grid item>
						<Typography
							style={{
								color: fontStyle,
								padding: 10,
								paddingLeft: 20,
								fontWeight: "bold",
							}}
						>
							{board.betSlip.join("")}
							{e_date ? (
								<>
									<span
										style={{
											fontStyle: "italic",
											color: "#789",
											display: "inline-block",
											marginLeft: 4,
											fontSize: 14,
										}}
									>
										{datePhpFormat2(date)}
									</span>
									{win ? (
										<span
											style={{
												fontStyle: "italic",
												display: "inline-block",
												marginLeft: 4,
												fontSize: 14,
											}}
										>
											Win
										</span>
									) : null}
								</>
							) : null}
						</Typography>
					</Grid>
					<Grid item>
						{eachBet.betType === "System Entry" ||
						eachBet.betType === "iBet" ? (
							<Grid item>
								<Typography
									style={{
										color: fontStyle,
										fontSize: 12,
										marginTop: -12,
										paddingLeft: 20,
									}}
								>
									{permuteCount(board.betSlip)} Permutations
								</Typography>
							</Grid>
						) : null}
					</Grid>
				</Grid>
				<Grid item xs={3}>
					<Typography
						style={{
							color: fontStyle2,
							padding: 10,
							fontWeight: "bold",
						}}
					>
						{board.big}
					</Typography>
				</Grid>
				<Grid item xs={3}>
					<Typography
						style={{
							color: fontStyle2,
							padding: 10,
							fontWeight: "bold",
						}}
					>
						{board.small}
					</Typography>
				</Grid>
			</Grid>
		</div>
	);
};

const DateTitle = ({ f_date }) => (
	<>
		<Grid item container>
			<Grid item xs={9}>
				<Typography
					variant="h5"
					style={{
						textTransform: "uppercase",
						fontSize: 18,
						fontWeight: "bold",
					}}
				>
					Draw Date
				</Typography>
			</Grid>
			<Grid item xs={3}>
				<Typography
					variant="h5"
					style={{
						textTransform: "uppercase",
						fontSize: 18,
						fontWeight: "bold",
					}}
				>
					Draw No.
				</Typography>
			</Grid>
		</Grid>
		{f_date.map((eachDate, eachDateCtr) => (
			<Grid item container key={eachDateCtr}>
				<Grid item xs={9}>
					<Typography>
						{eachDate.date === "2023-08-04" ||
						eachDate.date === "2023-12-21" ||
						eachDate.date === "2024-01-05" ||
						eachDate.date === "2024-08-02" ||
						eachDate.date === "2025-01-03" ||
						eachDate.date === "2025-02-07" ||
						eachDate.date === "2025-04-28" ||
						eachDate.date === "2025-06-19" ||
						eachDate.date === "2025-07-17" ||
						eachDate.date === "2025-07-31" ||
						eachDate.date === "2025-08-08" ||
						eachDate.date === "2025-08-28" ||
						eachDate.date === "2025-09-29" ||
						eachDate.date === "2025-10-23"
							? dateFormat("D, d M Y, g:ia", eachDate.date + " 21:30:00")
							: dateFormat("D, d M Y, g:ia", eachDate.date + " 18:30:00")}
					</Typography>
				</Grid>
				<Grid item xs={3}>
					<Typography>{eachDate.no}</Typography>
				</Grid>
			</Grid>
		))}
	</>
);

const CardBookingSpecific = ({
	bet,
	children,
	leftSide = "",
	e_date = false,
}) => {
	return (
		<MainContainer
			render={
				<Grid container direction="column">
					<TopBar title="Bet Receipt" rightSide="" leftSide={leftSide}>
						<Grid container style={{ textAlign: "center" }}>
							<Grid item xs={12}>
								<Typography
									variant="h5"
									style={{
										marginTop: 5,
										fontStyle: "italic",
										fontSize: 18,
										textTransform: "uppercase",
									}}
								>
									{bet.bookNo}
								</Typography>
								<Typography style={{ marginTop: 5, fontSize: 16 }}>
									Bet(s) successfully placed on
									<br />
									{dateFormat("d M Y h:i A", bet.createdAt).toUpperCase()}
								</Typography>
								<CheckCircleIcon
									style={{
										color: "green",
										backgroundColor: "#fff",
										borderRadius: "50%",
										fontSize: 70,
										position: "relative",
										zIndex: 1,
									}}
								/>
							</Grid>
						</Grid>
					</TopBar>
				</Grid>
			}
			style={{ height: 170 }}
		>
			{bet.type === "4d"
				? bet.bet.map((eachBet, eachBetKey) => (
						<div
							key={eachBetKey}
							style={{
								borderBottom: "1px solid #222",
								paddingBottom: 10,
							}}
						>
							<DateTitle f_date={eachBet.f_date} />
							<Grid container style={{ marginTop: 50 }}>
								<Grid item xs={6} style={{ marginTop: 10 }}>
									<Typography
										variant="h5"
										style={{
											textTransform: "uppercase",
											fontSize: 18,
											fontWeight: "bold",
										}}
									>
										{eachBet.betType}
									</Typography>
									<Typography>{eachBet.board.length} Board(s)</Typography>
								</Grid>
							</Grid>
							<Card
								style={{
									backgroundColor: "#F7F7F7",
									position: "relative",
									borderRadius: 16,
									marginTop: 10,
									marginBottom: 10,
								}}
							>
								<Grid
									container
									style={{
										backgroundColor: Global.color,
										opacity: 1,
										color: "#fff",
									}}
								>
									<Grid item xs={6}></Grid>
									<Grid item xs={3}>
										<Typography
											variant="subtitle1"
											style={{
												fontSize: 12,
												padding: 10,
												textTransform: "uppercase",
											}}
										>
											Big
										</Typography>
									</Grid>
									<Grid item xs={3}>
										<Typography
											variant="subtitle1"
											style={{
												fontSize: 12,
												padding: 10,
												textTransform: "uppercase",
											}}
										>
											Small
										</Typography>
									</Grid>
								</Grid>
								{!e_date
									? eachBet.board.map((board, boardKey) => (
											<DesignEachNumber
												eachBet={eachBet}
												board={board}
												boardKey={boardKey}
												key={boardKey}
											/>
									  ))
									: eachBet.e_date.map((e_date2, e_dateKey) => {
											let boardKey = e_date2.a_set - 1;
											let board = eachBet.board[boardKey];
											return (
												<DesignEachNumber
													eachBet={eachBet}
													board={board}
													boardKey={boardKey}
													key={e_dateKey}
													e_date={e_date}
													date={e_date2.date}
													win={e_date2.win}
												/>
											);
									  })}
							</Card>
							<Grid container style={{ marginTop: 20 }}>
								<Grid item xs={9}>
									<Typography
										variant="h5"
										style={{
											fontWeight: "bold",
											color: "#6d6d6d",
											fontSize: 18,
										}}
									>
										Subtotal:
									</Typography>
								</Grid>
								<Grid item xs={3}>
									<Typography
										style={{
											fontWeight: "bold",
											color: "#6d6d6d",
											fontSize: 17,
										}}
									>
										${bet.sub[eachBetKey].toFixed(2)}
									</Typography>
								</Grid>
							</Grid>
						</div>
				  ))
				: null}

			{bet.type === "toto"
				? bet.bet?.map((eachBet, eachBetKey) => (
						<div
							key={eachBetKey}
							style={{
								borderBottom: "1px solid #222",
								paddingBottom: 10,
							}}
						>
							<DateTitle f_date={eachBet.f_date} />
							<Grid container style={{ marginTop: 50 }}>
								<Grid item xs={6} style={{ marginTop: 10 }}>
									<Typography
										variant="h5"
										style={{
											textTransform: "uppercase",
											fontSize: 18,
											fontWeight: "bold",
										}}
									>
										{eachBet.betType}
									</Typography>
									<Typography>{eachBet.placeBet.length} Board(s)</Typography>
								</Grid>
							</Grid>

							<Grid item>
								<Card
									style={{
										backgroundColor: "#F7F7F7",
										position: "relative",
										borderRadius: 16,
										marginTop: 10,
									}}
								>
									{eachBet.placeBet.map((b, bI) => {
										return (
											<div
												key={bI}
												style={{
													borderBottom: "1px solid #ddd",
													textAlign: "center",
												}}
											>
												{b.eachPlaceBet.map((c, cI) => (
													<Typography
														key={cI}
														style={{
															color: Global.color,
															padding: 10,
															fontWeight: "bold",

															paddingTop: 18,
															display: "inline-block",
															textAlign: "center",
															width: 30,
															marginLeft: 1,
															fontSize: 20,
														}}
													>
														{c}
													</Typography>
												))}
											</div>
										);
									})}
								</Card>
							</Grid>

							<Grid container style={{ marginTop: 20 }}>
								<Grid item xs={9}>
									<Typography
										variant="h5"
										style={{
											fontWeight: "bold",
											color: "#6d6d6d",
											fontSize: 18,
										}}
									>
										Subtotal:
									</Typography>
								</Grid>
								<Grid item xs={3}>
									<Typography
										style={{
											fontWeight: "bold",
											color: "#6d6d6d",
											fontSize: 17,
										}}
									>
										${bet.sub[eachBetKey].toFixed(2)}
									</Typography>
								</Grid>
							</Grid>
						</div>
				  ))
				: null}

			{bet?.sum !== undefined ? (
				<Grid
					container
					style={{
						padding: 20,
						paddingLeft: 0,
						paddingRight: 0,
						backgroundColor: "#e7e7e7",
						marginLeft: -16,
						width: "calc(100% + 30px)",
						borderTop: "0.5px solid #C4C4C4",
						borderBottom: "0.5px solid #C4C4C4",
						marginTop: 16,
					}}
				>
					<Grid item xs={9}>
						<Typography
							variant="h5"
							style={{
								fontWeight: "bold",
								color: "#6d6d6d",
								fontSize: 24,
								paddingLeft: 16,
							}}
						>
							Total Stake:
						</Typography>
					</Grid>
					<Grid item xs={3}>
						<Typography
							style={{
								fontWeight: "bold",
								color: "#6d6d6d",
								fontSize: 23,
							}}
						>
							${bet.sum.toFixed(2)}
						</Typography>
					</Grid>
				</Grid>
			) : null}
			{children}
		</MainContainer>
	);
};

export default CardBookingSpecific;
